"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var summaryStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        extendedWrapper: {
            boxShadow: "1px 1px 4px 1px rgba(0,0,0,.1)",
            border: "1px solid " + palette.primaryDisabled.main,
            width: '100%',
        },
        extendedElementsWrapper: {
            padding: '20px 15px',
        },
    });
}, { name: 'Summary' });
exports.default = summaryStyles;
